// extracted by mini-css-extract-plugin
export default {"account_subscription_card_body":"J-","account_subscription_card_img":"K-","account_subscription_card_lower_section":"L-","account_subscription_card_category":"M-","account_subscription_card_title":"N-","account_subscription_card_price_section":"O-","account_subscription_card_servings":"P-","account_subscription_card_prices":"Q-","account_subscription_card_price":"R-","account_subscription_card_price_actual":"S-"};
    if(module.hot) {
      // 1714654898662
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  